import { Box } from "@mui/material";
import React from "react";
import messages from "../../_i18n/fr.json";
import styles from "./styles";

interface Props {
  statut?: string;
}
// tslint:enable: quotemark

const Statut: React.FC<Props> = ({ statut }: Props) => {
  let className = "statut";
  if (statut) {
    if (["VALIDE_AGREE", "VALIDE", "ACCEPTED"].includes(statut)) {
      className += " " + "green";
    } else if (
      [
        "VALIDE_AGREE_DIFFERE",
        "COMPLET",
        "INITIALIZED",
        "PENDING",
        "WAITING",
        "SUSPENDED",
        "A_VERIFIER",
      ].includes(statut)
    ) {
      className += " " + "orange";
    } else {
      className += " " + "red";
    }
  }
  return (
    <Box className={className} sx={styles}>
      {/* @ts-ignore */}
      {messages.statutDossierLocation[(statut as string) || "INCOMPLET"]}
    </Box>
  );
};

export default Statut;
